export function getUrl(url) {
  return "https://riktam-backend-601697113875.asia-southeast1.run.app/form_submission";
  // var baseUrl =
  //   !process.env.NODE_ENV || process.env.NODE_ENV === "development"
  //     ? "http://localhost:3000"
  //     : "https://www.riktam.com"

  // switch (url) {
  //   /////////////////////////////////////////////////////////login/////////////////////////////////////////////////////////
  //   case "webform":
  //     return baseUrl + "/form_submission"
  //   default:
  //     return baseUrl
  // }
}
